import React, { useState, useEffect } from 'react';
import instagramService from '../services/instagramService';
import InstagramComments from '../components/InstagramComments';

import Loading from '../components/Loading';
const InstagramCommentsPage = () => {
  const [accounts, setAccounts] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchAccounts();
  }, []);

  const fetchAccounts = async () => {
    try {
      const response = await instagramService.getAccounts();

      if (response.data && Array.isArray(response.data) && response.data.length > 0) {
        setAccounts(response.data);
        setSelectedAccount(response.data[0]);
      } else {
        setError('No hay cuentas de Instagram conectadas');
      }
    } catch (err) {
      console.error('Error fetching Instagram accounts:', err);
      setError('Error al cargar las cuentas de Instagram. Por favor, conecta una cuenta primero.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Loading fullScreen={false} mensaje="Cargando cuentas" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mx-auto p-6">
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
          {error}
        </div>
        <div className="mt-4">
          <a
            href="/instagram/connect/"
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
          >
            Conectar cuenta de Instagram
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto p-6">
      {accounts.length > 1 && (
        <div className="mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Selecciona una cuenta:
          </label>
          <select
            value={selectedAccount?.instagram_id || ''}
            onChange={(e) => {
              const account = accounts.find(a => a.instagram_id === e.target.value);
              setSelectedAccount(account);
            }}
            className="block w-full max-w-md px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
          >
            {accounts.map((account) => (
              <option key={account.instagram_id} value={account.instagram_id}>
                @{account.username}
              </option>
            ))}
          </select>
        </div>
      )}

      {selectedAccount && (
        <InstagramComments
          instagramId={selectedAccount.instagram_id}
          accountName={`@${selectedAccount.username}`}
        />
      )}
    </div>
  );
};

export default InstagramCommentsPage;
